var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0025 25.5C19.906 25.5 25.5025 19.9035 25.5025 13C25.5025 6.09644 19.906 0.5 13.0025 0.5C6.09889 0.5 0.502441 6.09644 0.502441 13C0.502441 19.9035 6.09889 25.5 13.0025 25.5ZM11.7525 17.375C11.7525 18.0654 12.3121 18.625 13.0025 18.625C13.6928 18.625 14.2525 18.0654 14.2525 17.375V14.25H17.3775C18.0678 14.25 18.6275 13.6904 18.6275 13C18.6275 12.3096 18.0678 11.75 17.3775 11.75H14.2525V8.625C14.2525 7.93465 13.6928 7.375 13.0025 7.375C12.3121 7.375 11.7525 7.93465 11.7525 8.625V11.75H8.62744C7.93709 11.75 7.37744 12.3096 7.37744 13C7.37744 13.6904 7.93709 14.25 8.62744 14.25H11.7525V17.375Z",
    fill: "#FE570B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon_plus.6b17a0264a140b3efd02105afd84e4d1.svg";
export { ForwardRef as ReactComponent };